import { PlusIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { LexOfficeRule } from '../apis/types';

import LexOfficeBookingRule from './LexOfficeBookingRule';

interface LexOfficeRulesFormProps {
  rules: LexOfficeRule[];
  onAddRule: () => void;
  onRemoveRule: (index: number) => void;
  onUpdateRule: (index: number, field: keyof LexOfficeRule, value: string) => void;
  addRuleDisabled?: boolean;
}

const LexOfficeRulesForm: React.FC<LexOfficeRulesFormProps> = ({
  rules,
  onAddRule,
  onRemoveRule,
  onUpdateRule,
  addRuleDisabled,
}) => {
  return (
    <div className='space-y-6'>
      <div className='space-y-4'>
        {rules.map((rule, index) => (
          <LexOfficeBookingRule
            key={index}
            rule={rule}
            onUpdate={(field, value) => onUpdateRule(index, field, value)}
            onRemove={() => onRemoveRule(index)}
          />
        ))}
      </div>
      <button
        type='button'
        onClick={onAddRule}
        disabled={addRuleDisabled}
        className='mt-2 flex items-center gap-1 text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-200 disabled:text-gray-400 disabled:dark:text-gray-600 disabled:cursor-not-allowed transition-colors'
      >
        <PlusIcon className='w-4 h-4' />
        Add rule
      </button>
    </div>
  );
};

export default LexOfficeRulesForm;
